const LayoutDefault = () =>
  import(/* webpackChunkName: "stockist" */ '@/layouts/LayoutDefault.vue');
const LayoutData = () =>
  import(/* webpackChunkName: "stockist" */ '@/layouts/LayoutData.vue');

const Dashboard = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/stockist/admin/dashboard/Index.vue'
  );

const DataDistributor = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/stockist/admin/pencatatan/data-distributor/Index.vue'
  );
const TambahDataDistributor = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/stockist/admin/pencatatan/data-distributor/Tambah.vue'
  );
const PerubahanData = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/stockist/admin/perubahan-data/Index.vue'
  );
const TambahPerubahanData = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/stockist/admin/perubahan-data/Tambah.vue'
  );

// Master
const Barang = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/stockist/admin/master/barang/Index.vue'
  );

const Ekspedisi = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/stockist/admin/master/ekspedisi/Index.vue'
  );

const SetupKasir = () =>
  import(
    /* webpackChunkName: "stockist" */ '@/views/pusat/admin/setup/Kasir.vue'
  );
const CekFaktur = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/CekFaktur.vue'
  );

let root = '/admin';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard | Admin',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cek-faktur',
    component: CekFaktur,
    meta: {
      auth: true,
      title: 'Cek Faktur',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/daftar-member/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Daftar Mitra Usaha',
    },
    children: [
      {
        path: '',
        component: DataDistributor,
        name: 'daftar-member',
        meta: {
          auth: true,
          title: 'Daftar Mitra Usaha | Admin',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-member',
        component: TambahDataDistributor,
        name: 'daftar-member.tambah',
        meta: {
          auth: true,
          title: 'Pencatatan Data Mitra Usaha | Admin',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Mitra Usaha',
        },
      },
      {
        path: ':id',
        component: TambahDataDistributor,
        name: 'daftar-member.edit',
        meta: {
          auth: true,
          title: 'Pencatatan Data Mitra Usaha | Admin',
          layout: LayoutDefault,
          breadcrumb: 'Detail Mitra Usaha',
        },
      },
    ],
  },
  {
    path: root + '/perubahan-data/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Perubahan Data',
    },
    children: [
      {
        path: '',
        component: PerubahanData,
        name: 'perubahan-data.index',
        meta: {
          auth: true,
          title: 'Perubahan Data | Admin',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah',
        component: TambahPerubahanData,
        name: 'perubahan-data.tambah',
        meta: {
          auth: true,
          title: 'Permintaan Perubahan Data Distributor | Admin',
          layout: LayoutDefault,
          breadcrumb: 'Perubahan Data',
        },
      },
    ],
  },
  {
    path: root + '/barang',
    component: Barang,
    meta: {
      auth: true,
      title: 'Barang',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/ekspedisi',
    component: Ekspedisi,
    name: 'expedition.index',
    meta: {
      auth: true,
      title: 'Ekspedisi',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/bank',
    component: SetupKasir,
    meta: {
      auth: true,
      title: 'Bank',
      layout: LayoutDefault,
    },
    props: {
      tabs: ['Metode Pembayaran'],
    },
  },
];
